export default class BackToTop {
   constructor() {
      this.item = document.querySelector('[data-back-to-top]')
      this.init()
   }

   init() {
      if (this.item && window.innerWidth > 1279) {
         window.addEventListener('load', () => this.trackScroll())
         window.addEventListener('scroll', () => this.trackScroll())
         this.item.addEventListener('click', () => this.backToTop())
      }
   }

   trackScroll() {
      const scrolled = window.pageYOffset
      const coords = document.documentElement.clientHeight
  
      if (scrolled > coords) {
         this.item.classList.add('back-to-top--show')
      }
      if (scrolled < coords) {
         this.item.classList.remove('back-to-top--show')
      }
    }
  
    backToTop() {
      if (window.pageYOffset > 0) { 
         window.scrollTo({top: 0, behavior: 'smooth'})
         // $('html, body').animate({scrollTop: 0 }, 'slow')
      }
    }
}



//////////////////
// WEBPACK FOOTER
// ./js/components/back-to-top.js
// module id = 8
// module chunks = 0